<template>
    <div class="company-view mb-3 mt-page">

        <h1>Manage Company: {{ company.name }}</h1>

        <b-row class="m-5">
            <b-col md="3" class="mb-3">
                <b-btn block variant="primary"
                       :to="updateRoute">
                    {{ this.$i18n.gt('LABEL_COMPANY_EDIT_DETAILS') }}
                </b-btn>
            </b-col>
            <b-col md="3" class="mb-3">
                <b-btn block variant="primary"
                       :to="plansRoute">
                    {{ this.$i18n.gt('LABEL_COMPANY_MANAGE_PLANS') }}
                </b-btn>
            </b-col>
            <b-col md="3" class="mb-3">
                <b-btn block variant="primary"
                       :to="practicesRoute">
                    {{ this.$i18n.gt('LABEL_COMPANY_MANAGE_PRACTICES') }}
                </b-btn>
            </b-col>
            <b-col v-if="isAdmin && !inProduction" md="3" class="mb-3">
                <b-btn block variant="primary"
                       :to="emrRoute">
                    {{ this.$i18n.gt('LABEL_COMPANY_EMR_ACCESS') }}
                </b-btn>
            </b-col>
        </b-row>
        <b-row class="m-5">
            <b-col md="3" class="mb-3">
                <b-btn block variant="primary"
                       :to="participantsRoute">
                    {{ this.$i18n.gt('LABEL_MANAGE_PARTICIPANTS') }}
                </b-btn>
            </b-col>
        </b-row>

        <!--        <router-link class="btn btn-primary ml-3"-->
        <!--                     :to="`/company/aggregateReport/id/${company.id}`">-->
        <!--            {{ $i18n.gt('LABEL_QUESTION_STATISTICS') }}-->
        <!--        </router-link>-->

    </div>
</template>

<script>

import Vue from 'vue'
import * as _ from 'lodash'
import User from "@/apps/default/User";

/**
 * Page for practitioner to edit a Biometrics record
 */
export default Vue.extend({
    name: 'CompanyView',
    props: {
        companyId: Number,
        resellerId: Number,
    },
    data() {
        return {
            company: {name: null},
            isAdmin: false,
            isCompanyAdmin: false,
            isResellerAdmin: false,
        }
    },
    async mounted() {
        this.company = await this.$api.getItem(this, 'company', this.companyId, [])
        this.isAdmin = this.$user.roleIsAdmin()
        this.isCompanyAdmin = this.$user.roleIsCompanyAdmin() && (this.$user.adminCompany().id === this.companyId)
        this.isResellerAdmin = this.$user.roleIsResellerAdmin() && (this.$user.reseller().id === this.resellerId)
    },
    computed: {
        updateRoute() {
            if (this.isCompanyAdmin) {
                return `/companyAdmin/update/id/${this.company.id}`
            } else if (this.isResellerAdmin) {
                return `/resellerAdmin/${this.resellerId}/company/update/id/${this.companyId}`
            } else {
                return `/company/update/id/${this.company.id}`
            }
        },
        inProduction () {
            return this.$api.inProduction
        },
        plansRoute() {
            if (this.isCompanyAdmin) {
                return `/companyAdmin/plans/id/${this.company.id}`
            } else if (this.isResellerAdmin) {
                return `/resellerAdmin/${this.resellerId}/company/plans/id/${this.companyId}`
            } else {
                return `/company/plans/id/${this.company.id}`
            }
        },
        practicesRoute() {
            if (this.isCompanyAdmin) {
                return `/practice/companyAdmin/companyId/${this.company.id}`
            } else if (this.isResellerAdmin) {
                return `/practice/resellerAdmin/${this.resellerId}/companyId/${this.companyId}`
            } else {
                return `/practice/admin/companyId/${this.company.id}`
            }
        },
        emrRoute() {
            if (this.isAdmin) {
                return `/company/emr/id/${this.company.id}`
            } else {
                return `/company/id/${this.company.id}`
            }
        },
        participantsRoute() {
            if (this.isResellerAdmin) {
                return `/participant/resellerAdmin/${this.resellerId}/company/${this.companyId}`
            } else {
                return `/participant/companyAdmin/${this.company.id}`
            }

        }
    },
})

</script>
